'use client';
import Image from 'next/image';

import { usePromoEvent } from '~features/promoEvent/hooks/usePromoEvent';
import LogoIcon from '~public/assets/logo.svg';
import { buildFullUrl } from '~shared/utils/images';

export const AppLogo = () => {
	const { logoUrl: promoEventLogoUrl } = usePromoEvent();

	return promoEventLogoUrl ? (
		<Image
			width={54}
			height={39}
			src={buildFullUrl(promoEventLogoUrl)}
			alt="promo event app logo"
			unoptimized
		/>
	) : (
		<LogoIcon />
	);
};
